import httpService from './httpService';

const search = (searchCredentials) => httpService.post('/api/search/find', searchCredentials);

export default { search };
